import { useState } from "react";

// Components
import CustomButton from "./CustomButton";

// Assets
// import copyIcon from "../assets/copy-icon.png";
// import checkIcon from "../assets/check-icon.png";

export default function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        // Reset the copied state after 2 seconds
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <CustomButton
      variant="transparent"
      onClick={copyToClipboard}
      // icon={copied ? checkIcon : copyIcon}
      icon ={copied ? "check" : "copy"}
      iconSize={18}
    />
  );
}
